import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { TaskRequestStatusModel } from '../../Models/Models/Tasks/TaskRequestStatusModel';

declare var IS_RUNNING_IN_APP_POOL;

export class TaskRequestStatusClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(taskRequestId: string): Promise<TaskRequestStatusModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Tasks/TaskRequestStatus/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { taskRequestId: taskRequestId }

    return AjaxWrapper.get<TaskRequestStatusModel, any>(url, data);
  }
}

